<div class="fundo" *ngIf="aberto" (click)="fechar.emit()"></div>
<aside class="painel" [class.aberto]="aberto" role="dialog" aria-label="Mensagem com a Mia" [attr.aria-hidden]="!aberto"
       [style.--cor]="segmento.cor" [style.--fundo]="segmento.fundo">
  <ng-container *ngIf="contato">
    <header class="painel-topo">
      <span class="avatar">{{ iniciais }}</span>
      <div class="ident">
        <strong>{{ contato.nome || 'Cliente' }}</strong>
        <span>{{ telefone }} · <b>{{ segmento.nomeSingular }}</b></span>
      </div>
      <button type="button" class="fechar" (click)="fechar.emit()" aria-label="Fechar"><i class="fe-x"></i></button>
    </header>

    <div class="painel-corpo">
      <section class="fatos">
        <span class="rotulo">A Mia vai considerar</span>
        <ul>
          <li *ngFor="let f of fatos"><i [class]="f.icone"></i>{{ f.texto }}</li>
        </ul>
        <p class="acao"><i class="fe-target"></i>{{ segmento.acao }}</p>
      </section>

      <section class="orientacao">
        <label class="rotulo" for="orientacaoMia">Como você quer a mensagem?</label>
        <div class="ideias">
          <button type="button" *ngFor="let ideia of ideias" [class.ativa]="orientacao === ideia" (click)="useIdeia(ideia)">{{ ideia }}</button>
        </div>
        <textarea id="orientacaoMia" rows="2" [(ngModel)]="orientacao" name="orientacaoMia"
                  placeholder="Opcional. Ex.: avisar que voltou o sabor de camarão e que hoje tem entrega grátis"></textarea>
        <button type="button" class="btn-escrever" (click)="escreva()" [disabled]="escrevendo">
          <i [class]="escrevendo ? 'fe-loader gira' : 'fe-zap'"></i>
          {{ escrevendo ? 'A Mia está escrevendo…' : (texto ? 'Escrever outra versão' : 'Escrever com a Mia') }}
        </button>
      </section>

      <section class="previa" *ngIf="texto">
        <div class="previa-topo">
          <span class="rotulo">Mensagem</span>
          <button type="button" class="copiar" (click)="copie()"><i [class]="copiado ? 'fe-check' : 'fe-copy'"></i>{{ copiado ? 'Copiado' : 'Copiar' }}</button>
        </div>
        <textarea rows="7" [(ngModel)]="texto" name="textoMia"></textarea>
        <span class="dica">Revise à vontade. [Link_Cardapio] vira o link do seu cardápio e [NomeContato] o nome do cliente no envio.</span>
      </section>

      <div class="mensagem aviso" *ngIf="!recebe"><i class="fe-bell-off"></i>Este cliente não recebe campanhas. Uma mensagem individual ainda pode ser enviada.</div>
      <div class="mensagem erro" *ngIf="erro"><i class="fe-alert-circle"></i>{{ erro }}</div>
      <div class="mensagem ok" *ngIf="enviado === 'fila'"><i class="fe-check"></i>Mensagem na fila do WhatsApp da loja. Sai em instantes.</div>
      <div class="mensagem ok" *ngIf="enviado === 'whatsapp'"><i class="fe-check"></i>Abrimos o WhatsApp com a mensagem pronta para você enviar.</div>
    </div>

    <footer class="painel-rodape">
      <button type="button" class="btn-secundario" (click)="fechar.emit()">Fechar</button>
      <button type="button" class="btn-primario" (click)="envie()" [disabled]="!texto.trim() || enviando || enviado === 'fila'">
        <i [class]="enviando ? 'fe-loader gira' : 'fab fa-whatsapp'"></i>{{ enviando ? 'Enviando…' : 'Enviar pelo WhatsApp' }}
      </button>
    </footer>
  </ng-container>
</aside>
